import React, { createContext, useState, useContext } from "react";
import api from "./axiosConfig";
import { getUser } from "./helpers";
const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [openModal, setOpenModal] = useState(false);
  const [customOpenModal, setCustomOpenModal] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editingValue, setEditingValue] = useState("");
  const [editingColumn, setEditingColumn] = useState("");
  const [lineData, setLineData] = useState([]);
  const [lineDataClick, setLineClick] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [filters, setFilters] = useState();
  const [mode, setMode] = useState("");
  const [newSchemeModalOpen, setNewSchemeModalOpen] = useState(false);
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [currency, setCurrency] = useState(
    localStorage.getItem("currency") ?? "INR"
  );
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const user = getUser();
  const transformFilters = (filters) => {
    if (filters) {
      return Object.fromEntries(
        Object.entries(filters).map(([key, { values }]) => [key, values])
      );
    }
    return filters;
  };

  const openModalWithValues = (
    row,
    column,
    warehouse_changes = "",
    channel_changes = "",
    pricelist_changes = "",
    startOfMonth = "",
    endOfMonth = ""
  ) => {
    setEditingRow(row);
    setEditingColumn(column);
    setEditingValue(row.values[column]);
    setOpenModal(true);
    //console.log("Open Modal"+JSON. stringify(row.values))
    //console.log("Warehouse"+warehouse)
    var warehouse = row.values["Warehouse"];
    var channel = row.values["Channel"];
    var pricelist = row.values["Category"];
    var productcode = row.values["Product"];
    //var channel=
    if (row.values["Warehouse"] == undefined) {
      warehouse = warehouse_changes;
    }

    //console.log("warehouse"+warehouse)
    if (channel == undefined) {
      channel = channel_changes;
    }
    if (pricelist == undefined) {
      pricelist = pricelist_changes;
    }
    setSaveLoading(true);

    const transformedFilters = transformFilters(filters);

    api
      .post("/getdetails", {
        body: {
          Warehouse: warehouse,
          Date: column,
          Channel: channel,
          Pricelist: pricelist,
          ProductCode: productcode,
          startdayofmonth: startOfMonth,
          enddayofmonth: endOfMonth,
          filters: transformedFilters,
          user: user,
          currencyType: currency,
        },
      })
      .then((response) => {
        // console.log(response.data)

        setLineData(response.data);
        setLineClick({
          Warehouse: warehouse,
          Date: column,
          Channel: channel,
          Pricelist: pricelist,
          ProductCode: productcode,
        });
        setSaveLoading(false);
        //setData(updatedData);
        //handleCloseModal();
        //setOpenModal(true);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setSaveLoading(false);
      });
  };
  const openModalWithAGValues = (
    row,
    column,
    warehouse_changes = "",
    channel_changes = "",
    pricelist_changes = "",
    startOfMonth = "",
    endOfMonth = ""
  ) => {
    setEditingRow(row);
    setEditingColumn(column);

    setEditingValue(row ? row[column] : "");
    setOpenModal(true);

    //console.log("Open Modal"+JSON. stringify(row.values))
    //console.log("Warehouse"+warehouse)
    var warehouse = row?.Warehouse;
    var channel = row?.OutletType;
    var pricelist = row?.Pricelist;
    var productcode = row?.ProductCode;
    //var channel=
    if (row?.Warehouse == undefined) {
      warehouse = warehouse_changes;
    }

    //console.log("warehouse"+warehouse)
    if (channel == undefined) {
      channel = channel_changes;
    }
    if (pricelist == undefined) {
      pricelist = pricelist_changes;
    }
    if (productcode == undefined) {
      productcode = "";
    }
    setSaveLoading(true);

    const transformedFilters = transformFilters(filters);
    api
      .post("/getdetails", {
        body: {
          Warehouse: warehouse,
          Date: column,
          Channel: channel,
          Pricelist: pricelist,
          ProductCode: productcode,
          startdayofmonth: startOfMonth,
          enddayofmonth: endOfMonth,
          filters: transformedFilters,
          user: user,
          currencyType: currency,
        },
      })
      .then((response) => {
        //console.log(response.data)

        setLineData(response.data);
        setLineClick({
          Warehouse: warehouse,
          Date: column,
          Channel: channel,
          Pricelist: pricelist,
          ProductCode: productcode,
          startdayofmonth: startOfMonth,
          enddayofmonth: endOfMonth,
        });
        setSaveLoading(false);
        //setData(updatedData);
        //handleCloseModal();
        //setOpenModal(true);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setSaveLoading(false);
      });
  };

  const openModalWithAGValues02 = (
    row,
    startOfMonth = "",
    setEditValue,
    RowColumns,
    clickedDate,
    page
  ) => {
    setEditingRow(row);
    setOpenModal(true);

    var warehouse = row?.Warehouse;
    var channel = row?.OutletType;
    var pricelist="";
    var category = "";
    if (page !== "dayleveledit") {
      pricelist = RowColumns?.includes("Pricelist") ? row?.Pricelist : "";
      category = RowColumns?.includes("Category") ? row?.Category : "";
    } else {
      pricelist = row?.Pricelist??"";
      category = row?.Category??"";
    }
    var productcode = row?.ProductCode??"";

    const validDate = clickedDate || "M";

    setSaveLoading(true);
    setLoading(true);

    const transformedFilters = transformFilters(filters);
    api
      .post("/getdetails", {
        body: {
          Warehouse: warehouse,
          Date: validDate,
          Channel: channel,
          Pricelist: pricelist,
          Category: category,
          ProductCode: productcode,
          startdayofmonth: startOfMonth,
          // enddayofmonth: endOfMonth,
          filters: transformedFilters,
          page: page,
          user: user,
          currencyType: currency,
        },
      })
      .then((response) => {
        setLineData(response.data);
        setLoading(false);
        setLineClick({
          Warehouse: warehouse,
          Date: validDate,
          Channel: channel,
          Pricelist: pricelist,
          Category: category,
          ProductCode: productcode,
          startdayofmonth: startOfMonth,
          page: page,
          user: user,
          currencyType: currency,
          // schemeType: OnInvoice,
          // enddayofmonth: endOfMonth,
        });
        setSaveLoading(false);
        setEditValue(response.data);
        setOpenModal(true);
        //setData(updatedData);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setSaveLoading(false);
        setLoading(false);
      });
  };

  const closeModalwithValues = () => {
    setOpenModal(false);
    setEditingRow(null);
    setEditingColumn("");
    setEditingValue("");
  };

  const closeModal = () => {
    setCustomOpenModal(false);
  };

  const openModalWithAScheme = (row, type) => {
    setCustomOpenModal(true);
    setEditingValue(row);
    setMode(type);
  };

  const closeAlertModal = () => {
    setCustomOpenModal(true);
  };

  return (
    <ModalContext.Provider
      value={{
        openModal,
        customOpenModal,
        mode,
        setOpenModal,
        setCustomOpenModal,
        editingRow,
        //setEditingRow,
        editingValue,
        setEditingValue,
        editingColumn,
        //setEditingColumn,
        lineData,
        setLineData,
        openModalWithValues,
        openModalWithAGValues,
        openModalWithAGValues02,
        closeModalwithValues,
        lineDataClick,
        setLineClick,
        saveLoading,
        setSaveLoading,
        openModalWithAScheme,
        closeModal,
        setFilters,
        newSchemeModalOpen,
        setNewSchemeModalOpen,
        alertModalOpen,
        setAlertModalOpen,
        closeAlertModal,
        currency,
        setCurrency,
        hasActiveFilters,
        setHasActiveFilters,
        isLoading,
        setLoading,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);
